/* ============================================
   PRODUCT FORM — Quantity & Gallery
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {
  // Quantity selector
  const quantitySelectors = document.querySelectorAll('.product-quantity-selector');
  quantitySelectors.forEach(function(selector) {
    const input = selector.querySelector('input');
    const minus = selector.querySelector('[data-quantity-minus]');
    const plus = selector.querySelector('[data-quantity-plus]');

    if (minus) {
      minus.addEventListener('click', function() {
        const val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
        updateAddToCartPrice();
      });
    }

    if (plus) {
      plus.addEventListener('click', function() {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
        updateAddToCartPrice();
      });
    }
  });

  // Image gallery
  const mainImage = document.querySelector('.product__main-image');
  const thumbnails = document.querySelectorAll('.product__thumbnail');

  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbnails.forEach(t => t.classList.remove('is-active'));
      this.classList.add('is-active');
      if (mainImage) {
        mainImage.src = this.dataset.fullImage || this.src;
        mainImage.alt = this.alt;
      }
    });
  });

  // Update add to cart button price
  function updateAddToCartPrice() {
    const btn = document.querySelector('.product__add-to-cart');
    const input = document.querySelector('.product-quantity-selector input');
    const priceEl = document.querySelector('[data-product-price]');

    if (btn && input && priceEl) {
      const qty = parseInt(input.value) || 1;
      const price = parseFloat(priceEl.dataset.productPrice);
      btn.textContent = `Add to Bag — £${(price * qty).toFixed(2)}`;
    }
  }

  // Review form toggle
  const writeReviewBtn = document.querySelector('[data-write-review]');
  const reviewForm = document.querySelector('.review-form');

  if (writeReviewBtn && reviewForm) {
    reviewForm.style.display = 'none';
    writeReviewBtn.addEventListener('click', function() {
      const isVisible = reviewForm.style.display !== 'none';
      reviewForm.style.display = isVisible ? 'none' : 'block';
      if (!isVisible) {
        reviewForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  // Star rating in review form
  const starButtons = document.querySelectorAll('.review-form__stars button');
  const ratingInput = document.querySelector('[name="review-rating"]');

  starButtons.forEach(function(btn, index) {
    btn.addEventListener('click', function() {
      const rating = index + 1;
      if (ratingInput) ratingInput.value = rating;

      starButtons.forEach(function(b, i) {
        const svg = b.querySelector('svg');
        if (svg) {
          if (i < rating) {
            svg.classList.add('star-filled');
            svg.classList.remove('star-empty');
          } else {
            svg.classList.remove('star-filled');
            svg.classList.add('star-empty');
          }
        }
      });
    });
  });
});
